import { render, staticRenderFns } from "./InstituteToUserAssignment.vue?vue&type=template&id=758fb2c9"
import script from "./InstituteToUserAssignment.vue?vue&type=script&lang=ts"
export * from "./InstituteToUserAssignment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports